import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { colours, sizes } from '@qflow/theme'
import { Drawer } from 'antd'

import { useCountryDrivenValues } from 'portal/lib/hooks'
import { ColourButton, icons } from 'portal/lib/primitives'

import { moduleSectionFieldNameMapper } from './fieldNameMappers'
import {
  RecordHistoryFieldDetails,
  RecordHistoryItemWrapperDetails
} from './RecordHistoryFieldDetails'
import { RecordHistoryFieldSection } from './RecordHistoryFieldSection'
import { useRecordHistoryLoader } from './useRecordHistoryLoader'

export function RecordHistoryDrawer({
  open,
  setOpen,
  moduleName = 'delivery'
}) {
  const { loading, error } = useRecordHistoryLoader()

  const history = useSelector((state: any) => state.records.history)
  const historyObject = history.item

  const { wasteFields } = useCountryDrivenValues()

  const ModuleSections = moduleSectionFieldNameMapper(
    moduleName.toUpperCase(),
    wasteFields
  )

  return (
    <Drawer
      title={'Record history'}
      closeIcon={null}
      placement="right"
      open={open}
      loading={loading}
      onClose={() => setOpen(false)}
      extra={
        <CloseButton onClick={() => setOpen(false)}>
          <icons.Cross colour={colours.WHITE} size={sizes.SMALL} />
        </CloseButton>
      }
      width={350}
    >
      {error && <p>There was an error loading the history</p>}
      {historyObject && (
        <>
          {Object.keys(ModuleSections).map((section, index) => {
            // Handle Products and Items separately
            if (section !== 'Products' && section !== 'Items') {
              return (
                <RecordHistoryFieldSection
                  key={section}
                  section={section}
                  ModuleSection={ModuleSections[section]}
                  historyObject={historyObject}
                  index={index}
                />
              )
            } else {
              // Now handle Products and Items
              return (
                <div key={section}>
                  <SectionTitle style={index === 0 ? { marginTop: 0 } : {}}>
                    <div>{section}</div>
                  </SectionTitle>
                  <FieldWarpper>
                    {historyObject[section.toLowerCase()] &&
                      historyObject[section.toLowerCase()].map(
                        (item, index: number) => {
                          return (
                            <RecordHistoryItemWrapperDetails
                              key={index}
                              item={item}
                              moduleName={moduleName}
                            >
                              <FieldWarpper key={index}>
                                {ModuleSections[section].map(key => {
                                  return (
                                    <RecordHistoryFieldDetails
                                      fieldName={key}
                                      historyObject={item[key]}
                                      key={key}
                                    />
                                  )
                                })}
                              </FieldWarpper>
                            </RecordHistoryItemWrapperDetails>
                          )
                        }
                      )}
                  </FieldWarpper>
                </div>
              )
            }
          })}
        </>
      )}
    </Drawer>
  )
}

const SectionTitle = styled.div`
  font-family: 'Jakarta Sans', 'Inter', sans-serif !important;
  font-size: 15px;
  font-weight: 700;
  color: ${colours.CORE_NAVY};
  margin: 1.25rem 0 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const CloseButton = styled(ColourButton.BasicBorderless)`
  background: transparent;

  &:hover {
    background: transparent;
  }
`
const FieldWarpper = styled.div`
  padding: 0;
  border: 1px solid ${colours.CLOUD_GREY};
  border-radius: 10px;

  & > details:last-of-type {
    border-bottom: none;
  }
`
